import React, { useState } from "react";
import { Alert } from "@mui/material";

const PDFViewer = ({ pdfUrl, fileName }) => {
  const [zoom, setZoom] = useState(100);

  if (!pdfUrl) {
    return (
      <Alert severity="error" className="pdf-error">
        URL del PDF non specificato
      </Alert>
    );
  }

  const viewerUrl = `${pdfUrl}#navpanes=0&view=fitW`;

  return (
    <div className="pdf-container">
      <div className="pdf-viewer">
        <div
          className="pdf-frame-container"
          style={{
            width: `${zoom}%`,
            height: "100%",
          }}
        >
          <iframe
            src={viewerUrl}
            title={fileName || "Documento PDF"}
            className="pdf-frame"
            allowFullScreen
          />
        </div>
      </div>
    </div>
  );
};

export default PDFViewer;